// extracted by mini-css-extract-plugin
export var callCard = "_qf-0";
export var callMessageButton = "_qf-1";
export var helpIcon = "_qf-3";
export var helpIconContainer = "_qf-4";
export var verticalDivider = "_qf-2";